const { getElements } = window.BAO.Utils
class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.conversion = this.dataset.conversion
    this.headings = this.dataset.headings

    this.garmentTable = this.els?.garment?.element?.querySelector('table')
    this.bodyTable = this.els?.body?.element?.querySelector('table')
    this.sizeTable = this.els?.size?.element?.querySelector('table')

    if (this?.dataset?.showConverter === 'true') {
      this.handleInitialConversion()
    }

    this.handleInitialHeadings()
    this.setInitialTab()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach(el => {
        this.listeners.add(el, 'click', this.handleTrigger)
      })
    }

    if (this.els?.inches?.exists) {
      this.onInchesClick = this.onInchesClick.bind(this)

      this.els.inches.elements.forEach(el => {
        this.listeners.add(el, 'click', this.onInchesClick)
      })
    }

    if (this.els?.centimetres?.exists) {
      this.onCentimetresClick = this.onCentimetresClick.bind(this)

      this.els.centimetres.elements.forEach(el => {
        this.listeners.add(el, 'click', this.onCentimetresClick)
      })
    }

    if (this.els?.select?.exists) {
      this.onSelectChange = this.onSelectChange.bind(this)

      this.els.select.elements.forEach(el => {
        this.listeners.add(el, 'change', this.onSelectChange)
      })
    }
  }

  onSelectChange () {
    const value = this.els.select.element.value

    getElements('tr:first-child td', { context: this.garmentTable }).forEach(
      el => {
        if (el.cellIndex === 0) return

        const currentValue = el.dataset.value
        const currentObject = this.conversions[this.headings]
        if (!currentObject) return

        const valueIndex = currentObject.findIndex(
          el => String(el) === String(currentValue),
        )

        const newObject = this.conversions[value]
        if (!newObject) return

        const newValue = newObject[valueIndex]
        if (!newValue) return

        el.innerHTML = newValue
      },
    )

    getElements('tr:first-child td', { context: this.bodyTable }).forEach(
      el => {
        if (el.cellIndex === 0) return

        const currentValue = el.dataset.value
        const currentObject = this.conversions[this.headings]
        if (!currentObject) return

        const valueIndex = currentObject.findIndex(
          el => String(el) === String(currentValue),
        )

        const newObject = this.conversions[value]
        if (!newObject) return

        const newValue = newObject[valueIndex]
        if (!newValue) return

        el.innerHTML = newValue
      },
    )
  }

  setInitialTab () {
    const activeTab = this.querySelector(
      '[data-size-guide-el="trigger"][aria-pressed="true"]',
    )

    if (!activeTab) return

    const activeTabValue = activeTab.dataset.tab

    this.setAttribute('data-tab', activeTabValue)
  }

  handleInitialConversion () {
    const handleConversion = el => {
      if (el.cellIndex === 0 || el.closest('tr').rowIndex === 0) return

      if (isNaN(el.innerHTML)) return

      const centimetres = parseFloat(el.innerHTML, 10)

      if (isNaN(centimetres)) return

      const inches = Math.round((centimetres / 2.54) * 10) / 10

      el.setAttribute('data-centimetres', centimetres)
      el.setAttribute('data-inches', inches)

      if (this.conversion === 'centimetres') {
        el.innerHTML = centimetres
      } else {
        el.innerHTML = inches
      }
    }

    if (this.garmentTable !== undefined) {
      getElements('td', { context: this.garmentTable }).forEach(el =>
        handleConversion(el),
      )
    }

    if (this.bodyTable !== undefined) {
      getElements('td', { context: this.bodyTable }).forEach(el =>
        handleConversion(el),
      )
    }
  }

  handleInitialHeadings () {
    const handleHeadings = el => {
      if (el.cellIndex === 0) return

      const value = el.innerHTML

      el.setAttribute('data-value', value)

      const currentObject = this.conversions[this.headings]
      if (!currentObject) return

      const valueIndex = currentObject.findIndex(
        el => String(el) === String(value),
      )

      const newObject = this.conversions[this.headings]
      if (!newObject) return

      const newValue = newObject[valueIndex]
      if (!newValue) return

      el.innerHTML = newValue
    }

    getElements('tr:first-child td', { context: this.garmentTable }).forEach(
      el => handleHeadings(el),
    )

    getElements('tr:first-child td', { context: this.bodyTable }).forEach(el =>
      handleHeadings(el),
    )
  }

  async onInchesClick () {
    this.convertToInches()

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: 'inches',
        },
      }),
    })
  }

  async onCentimetresClick () {
    this.convertToCentimetres()

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: 'centimetres',
        },
      }),
    })
  }

  convertToInches () {
    if (this.conversion === 'inches') return

    this.conversion = 'inches'

    this.els.inches.elements.forEach(el => {
      el.setAttribute('aria-current', true)
    })

    this.els.centimetres.elements.forEach(el => {
      el.setAttribute('aria-current', false)
    })

    getElements('td', { context: this.garmentTable }).forEach(el => {
      if (!el.hasAttribute('data-inches')) return

      el.innerHTML = el.dataset.inches
    })

    getElements('td', { context: this.bodyTable }).forEach(el => {
      if (!el.hasAttribute('data-inches')) return

      el.innerHTML = el.dataset.inches
    })
  }

  convertToCentimetres () {
    if (this.conversion === 'centimetres') return

    this.conversion = 'centimetres'

    this.els.inches.elements.forEach(el => {
      el.setAttribute('aria-current', false)
    })

    this.els.centimetres.elements.forEach(el => {
      el.setAttribute('aria-current', true)
    })

    getElements('td', { context: this.garmentTable }).forEach(el => {
      if (!el.hasAttribute('data-centimetres')) return

      el.innerHTML = el.dataset.centimetres
    })

    getElements('td', { context: this.bodyTable }).forEach(el => {
      if (!el.hasAttribute('data-centimetres')) return

      el.innerHTML = el.dataset.centimetres
    })
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach(panelEl => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== triggerEl.dataset.tab,
      )
    })

    this.els.trigger.elements.forEach(trigger => {
      trigger.setAttribute(
        'aria-pressed',
        trigger.dataset.tab === triggerEl.dataset.tab,
      )
    })

    this.setAttribute('data-tab', triggerEl.dataset.tab)
  }

  get storageName () {
    return 'size_guide_conversion'
  }

  get conversions () {
    return {
      UK: [
        'UK 6',
        'UK 8',
        'UK 10',
        'UK 12',
        'UK 14',
        'UK 16',
        'UK 18',
        'UK 20',
      ],
      US: ['2', '4', '6', '8', '10', '12', '14', '16'],
      Italian: ['38', '40', '42', '44', '46', '48', '50', '52'],
      French: ['34', '36', '38', '40', '42', '44', '46', '48'],
      Japan: ['5', '7', '9', '11', '13', '15', '17', '19'],
      Denmark: ['32', '34', '36', '38', '40', '42', '44', '46'],
      Universal: ['XS', 'XS-S', 'S-M', 'M-L', 'L-XL', 'XL', 'XL', 'XXL'],
    }
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
